export default {"src":"/_next/static/media/africasasa.eeb6490d.svg","height":351,"width":554};